import React, { ReactElement } from 'react'
import { UseFormRegister, UseFormHandleSubmit, SubmitHandler, UseFormSetValue, UseFormReset } from 'react-hook-form'
import { FaThumbsDown, FaQuestion } from 'react-icons/fa'

import { camelCaseToClassicCase } from './FormValues'

export default function FormButtons({
  level,
  name,
  register,
  handleSubmit,
  onSubmit,
  setValue,
  reset,
  defaultValues,
}: {
  level: number
  name: string
  register: UseFormRegister<Record<string, boolean>>
  handleSubmit: UseFormHandleSubmit<Record<string, boolean>>
  onSubmit: SubmitHandler<Record<string, boolean>>
  setValue: UseFormSetValue<Record<string, boolean>>
  reset: UseFormReset<Record<string, boolean>>
  defaultValues: Record<string, boolean>
}): ReactElement {
  let lvl = 'weak'
  let icon: ReactElement | null = null
  if (level === 0) {
    lvl = 'strong'
    icon = <FaThumbsDown size={18} />
  } else if (level === 1) {
    icon = <FaQuestion size={18} />
  }

  const inputClassName = `${lvl}LevelButton`
  const iconClassName = `${lvl}LevelIcon`

  register(`${name}`, { value: false })

  const onClick = handleSubmit(data => {
    setValue(name, true, { shouldValidate: true })
    onSubmit(data)
    reset(defaultValues)
  })

  return (
    <button type="button" className={inputClassName} onClick={onClick}>
      {icon ? <i className={iconClassName}>{icon}</i> : null} {camelCaseToClassicCase(name)}
    </button>
  )
}
